const Config = () => import('@/modules/system/config/config.vue')
const SsoManage = () => import('@/modules/system/sso/ssoManage.vue')

export default [
  {

    path: '/config',
    name: 'config',
    component: Config,
    meta: {
      title: '参数配置',
      isBlack: true
    },
  },
  {

    path: '/sso',
    name: 'sso',
    component: SsoManage,
    meta: {
      title: '授权管理',
      isBlack: true
    },
  }
]
